import { TableNoDataMessage } from "components/ReleaseForm";

export const ArtistsEmptyTableMessage = () => <TableNoDataMessage text="There are no artist(s) added." />;
